// eslint-disable-next-line import/prefer-default-export
export const partners = [
  {
    title: 'Zoom',
    assetName: 'logos/zoom-solid-alt.png',
    color: '#612A92',
    linkText: 'https://www.zoom.com.br',
    link: 'https://www.zoom.com.br?og=19352&utm_source=Parcelex&utm_medium=parceiro',
  },
  {
    title: 'Buscapé',
    assetName: 'logos/buscape-solid-alt.png',
    color: '#FFC600',
    link: 'https://www.buscape.com.br',
  },
  {
    title: 'Claro',
    assetName: 'logos/claro-solid.png',
    color: '#CB3727',
    link: 'https://www.claropromo.com.br',
  },
  {
    title: 'Vivo',
    assetName: 'logos/vivo-solid.png',
    link: 'https://loja.vivo.com.br/',
  },
  {
    title: 'Avenida',
    assetName: 'logos/avenida-solid.png',
    link: 'https://www.avenida.com.br/',
  },
  {
    title: 'Everest',
    assetName: 'logos/everest-solid.png',
    link: 'https://www.softpurificadores.com.br/',
  },
  // {
  //   title: 'Motorola',
  //   assetName: 'motorola-logo.svg',
  //   color: '#071028',
  //   link: 'https://www.motorola.com.br',
  // },
  // {
  //   title: 'Americanas',
  //   assetName: 'americanas-logo.svg',
  //   color: '#d62324',
  //   link: 'https://www.americanas.com.br',
  // },
];
